import React from "react"
import Img from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby"

const HungerImages = ({ id }) => {
    const data = useStaticQuery(graphql`
        query {
            cover_a: file(relativePath: { eq: "hunger/motif/cover_a.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            cover_b: file(relativePath: { eq: "hunger/motif/cover_b.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            cover_c: file(relativePath: { eq: "hunger/motif/cover_c.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            cover_d: file(relativePath: { eq: "hunger/motif/cover_d.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            cover_e: file(relativePath: { eq: "hunger/motif/cover_e.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            cover_f: file(relativePath: { eq: "hunger/motif/cover_f.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            cover_g: file(relativePath: { eq: "hunger/motif/cover_g.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            cover_h: file(relativePath: { eq: "hunger/motif/cover_h.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }

            motif_a: file(relativePath: { eq: "hunger/motif/motif_a.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            motif_b: file(relativePath: { eq: "hunger/motif/motif_b.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            motif_c: file(relativePath: { eq: "hunger/motif/motif_c.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            motif_d: file(relativePath: { eq: "hunger/motif/motif_d.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            motif_e: file(relativePath: { eq: "hunger/motif/motif_e.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            motif_f: file(relativePath: { eq: "hunger/motif/motif_f.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
        }
    `)

    return (
        <Img style={{ width: "100%" }} fluid={data[id].childImageSharp.fluid} />
    )
}

export default HungerImages
